<template>
  <div>
    <div class="searchBox">
      <div class="searchLeft">
        <el-date-picker
        size="medium"
          v-model="searchForm.startTime"
          type="date"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptionsStart"
          placeholder="请选择开始时间">
        </el-date-picker>
        <el-date-picker
          size="medium"
          v-model="searchForm.endTime"
          type="date"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptionsEnd"
          placeholder="请选择结束时间">
        </el-date-picker>
        <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button>
        <a :href="url+'/userBalance/pledgeFilBalance/summary/export?startTime='+searchForm.startTime + '&&endTime='+searchForm.endTime" style="margin-left:20px">
          <el-button size="medium" type="warning" icon="el-icon-folder-opened">导出</el-button>
        </a>
      </div>
    </div>
    <el-table
      border
      :data="tableData"
      height="73vh"
      style="width: 100%">
      <el-table-column
        prop="date"
        label="时间">
      </el-table-column>
      <el-table-column
        prop="minerPledge"
        label="链上数据合计(当日)">
        <template slot-scope="scope">
          <span>{{$selfFunc.toNonExponential(Number(scope.row.minerPledge),4)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="userPledge"
        label="客户质押合计(当日)">
        <template slot-scope="scope">
          <span>{{$selfFunc.toNonExponential(Number(scope.row.userPledge),4)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="companyPledge"
        label="公司质押">
        <template slot-scope="scope">
          <span>{{$selfFunc.toNonExponential(Number(scope.row.companyPledge),4)}}</span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" align="center" prop="time" width="100">
        <template slot-scope="scope">
          <el-button size="mini" type="primary"   @click="goDetail(scope.row.date)"><i class="el-icon-view" style="margin-right:3px;"></i>查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageBox" v-if="totalNum > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[16, 32, 50, 60]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="详情"
      :visible.sync="dialogVisible"
      width="600px">
      <el-table
        border
        :data="tableDataDetail"
        style="width: 100%">
        <el-table-column
          prop="date"
          label="时间">
        </el-table-column>
        <el-table-column
          prop="nodeNumber"
          label="节点">
        </el-table-column>
        <el-table-column
          prop="minerPledge"
          label="链上数据FIL">
          <template slot-scope="scope">
            <span>{{$selfFunc.toNonExponential(Number(scope.row.minerPledge),4)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="userPledge"
          label="客户质押FIL">
          <template slot-scope="scope">
            <span>{{$selfFunc.toNonExponential(Number(scope.row.userPledge),4)}}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.searchForm.endTime;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.searchForm.startTime;
          if (beginDateVal) {
            return (time.getTime()<new Date(beginDateVal).getTime()-1*24*60*60*1000);
          }
        }
      },
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:16,
        startTime: '',
        endTime: '',
      },
      tableData: [],
      tableDataDetail:[],
      url: window.g.host,
      dialogVisible: false
    };
  },
  created() {
    this.getTableList()
  },
  methods: {
    // 获取详情
    async goDetail(date){
      this.dialogVisible = true
      let res = await this.$http.filBalanceSummaryDetail({date:date});
      if (res) {
        console.log(res)
        this.tableDataDetail = res.data
      }
    },
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
       let res = await this.$http.filBalanceSummaryList({...this.searchForm});
        if (res) {
          this.tableData=res.data.list
          console.log(res.data)
          this.totalNum=Number(res.data.totalSize)
        }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>
<style scoped>
.unit{
  position: absolute;
  right: 10px;
  color:#999;
}
</style>
